import { render } from "./NavBarTourism.vue?vue&type=template&id=3b2a1ca7&scoped=true"
import script from "./NavBarTourism.vue?vue&type=script&lang=js"
export * from "./NavBarTourism.vue?vue&type=script&lang=js"

import "./NavBarTourism.vue?vue&type=style&index=0&id=3b2a1ca7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b2a1ca7"]])

export default __exports__